import { ReactNode, useMemo, useState } from 'react';
import {
  SanitizedAnomalyAlert,
  SanitizedMlAlert,
  SanitizedNoticeAlert,
  SanitizedSearchBasedAlert,
  SanitizedSuricataAlert,
  SanitizedYaraAlert,
} from '../../../features/detections/pages';
import { Alert } from '@investigator/shared/generated/graphql';
import { PortalType, SlideDrawerContext } from './SlideDrawerContext';

interface SlideDrawerProviderProps {
  children?: ReactNode;
}

export const SlideDrawerProvider = ({ children }: SlideDrawerProviderProps) => {
  const [portalType, setPortalType] = useState<PortalType | undefined>();
  const [isSlideDrawerOpen, setIsSlideDrawerOpen] = useState<
    boolean | undefined
  >();
  const [slideDrawerTitle, setSlideDrawerTitle] =
    useState<ReactNode>(undefined);
  const [slideDrawerBody, setSlideDrawerBody] = useState<ReactNode>(undefined);
  const [slideDrawerActions, setSlideDrawerActions] =
    useState<ReactNode>(undefined);
  const [isNotesDrawerLoading, setIsNotesDrawerLoading] = useState<
    boolean | undefined
  >(false);
  const [slideDrawerOnClose, setSlideDrawerOnClose] = useState<
    (() => void) | undefined
  >(undefined);

  const [activeAlert, setActiveAlert] = useState<
    | null
    | Alert
    | SanitizedMlAlert
    | SanitizedNoticeAlert
    | SanitizedSuricataAlert
    | SanitizedSearchBasedAlert
    | SanitizedYaraAlert
    | SanitizedAnomalyAlert
  >(null);

  const slideDrawerContext = useMemo(() => {
    return {
      portalType,
      setPortalType,
      slideDrawerTitle,
      setSlideDrawerTitle,
      isSlideDrawerOpen,
      setIsSlideDrawerOpen,
      slideDrawerBody,
      setSlideDrawerBody,
      slideDrawerActions,
      setSlideDrawerActions,
      slideDrawerOnClose,
      setSlideDrawerOnClose,
      setIsNotesDrawerLoading,
      isNotesDrawerLoading,
      activeAlert,
      setActiveAlert,
    };
  }, [
    portalType,
    slideDrawerTitle,
    isSlideDrawerOpen,
    slideDrawerBody,
    slideDrawerActions,
    slideDrawerOnClose,
    isNotesDrawerLoading,
    activeAlert,
  ]);
  return (
    <SlideDrawerContext.Provider value={{ ...slideDrawerContext }}>
      {children}
    </SlideDrawerContext.Provider>
  );
};
